import { render } from "./userGameRolling.vue?vue&type=template&id=246e296c&scoped=true"
import script from "./userGameRolling.vue?vue&type=script&lang=js"
export * from "./userGameRolling.vue?vue&type=script&lang=js"

import "./userGameRolling.vue?vue&type=style&index=0&id=246e296c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246e296c"]])

export default __exports__